
import { TweenLite } from "gsap";
import { MoneyFormatter } from "../MoneyFormatter";
import { DecodedImageResource, ImageResource } from "../ResourceManager/ImageResource";
import { Resourceful } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../ResourceManager/ResourceManager";
import { CreateElement, Scale, Size } from "../MyHelpers";
import { Settings } from "../Settings";
import { ZIndex } from "../ZIndex";
import { service } from "../services";
import { DenomSelectedCallback } from "./DenomMenu";
import * as PIXI from "pixi.js";
import gsap from "gsap";
//gsap.registerPlugin(gsap.plugins.pixi);

//export type DenomSelectedCallback = (denomCents: number) => void;

//type NewType = IWriteOnlyResourceManager;

export class DenomMenuPIXIAPP implements Resourceful
{
	protected denomCents:number [] = [];
	//protected view: HTMLElement = null;
	protected path:string = Settings.ResourcesFolder + "multigame/slot/common/resources/DenomMenu/";
	protected resid: ResourceIdentifier = null;

	//private denomButtons:HTMLButtonElement []= [];
	//protected denomMenu:HTMLElement = null;
	//protected denomInfo:HTMLElement = null;
	//protected denomTitle:HTMLElement = null;
	//protected denomContainer:HTMLElement = null;

	protected denomSelectedCalback:DenomSelectedCallback  = null;

	protected isLocked:boolean = false;



	//add base path game
	protected basePathGame:string=null;

	constructor(denomCents: number [], resid: ResourceIdentifier, basePathGame:string)
	{
		this.denomCents = denomCents;
		this.resid = resid.Add("DenomMenu");

		// this.view = CreateElement("div", {
		// 	classes: [this.resid.Scope()],
		// 	style: {
		// 		position: "absolute",
		// 		pointerEvents: "all",
		// 		width: "100%",
		// 		height: "100%",
		// 		top: "0px",
		// 		left: "0px",

		// 		backgroundColor: "rgba(0,0,0,0.5)",
		// 		fontFamily: "NotoSansDisplay-Bold",
		// 		zIndex:ZIndex.DemonContainer.toString(),
		// 	}
		// });

		this.basePathGame=basePathGame;
	}

	public PrepareResources(resourceManager: IWriteOnlyResourceManager)
	{
		//resourceManager.Add(new CSSResource(this.path + "denomMenu.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));

		resourceManager.Add(new DecodedImageResource(this.path + "denom-frame.png", this.resid.ScopedResourceName(["frame","image"])));
		//resourceManager.Add(new ImageResource(this.basePathGame + "resources/denom.png", this.resid.ScopedResourceName(["denom","image"])));

		resourceManager.Add(new DecodedImageResource(this.basePathGame + "resources/denom.png", this.resid.ScopedResourceName(["denom","image"])));
		
	}

	protected denomBackgroundImageTexturePIXI: PIXI.Texture<PIXI.Resource> = null;
	protected frameButtonImageTexturePIXI: PIXI.Texture<PIXI.Resource> = null;
	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager)
	{
		//create texture for denom background 
		let imageDecodeDenomBackground = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["denom","image"])).DecodedImage()
        this.denomBackgroundImageTexturePIXI = PIXI.Texture.from(imageDecodeDenomBackground);


		let frameImageDecodeDenomBackground = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["frame","image"])).DecodedImage()     
        this.frameButtonImageTexturePIXI = PIXI.Texture.from(frameImageDecodeDenomBackground);
		
		//this.Hide();

	}

	public DenomSelectedCallback(callback: DenomSelectedCallback): void {
		this.denomSelectedCalback = callback;
	}

	public View(): HTMLElement
	{
		return null;
	}

	public ViewPIXIAPP(): PIXI.Container
	{
		return this.viewPIXIAPP;
	}

	// protected visible: boolean = true;
	public Show() {
		if (this.viewPIXIAPP.visible) return;
		// this.visible = true;

		//this.view.style.visibility = "visible";
		//TweenLite.fromTo(this.denomInfo, 0.5, { scale: 0 }, { scale: 1 });
		//missing convert anim to gsap 
		this.viewPIXIAPP.visible = true;
		this.viewPIXIAPP.interactiveChildren = true;
		
		this.isLocked = true;
	}

	public Hide()
	{
		// if (!this.visible) return;
		// this.visible = false;

		//TweenLite.set(this.	, {scale:0});
		//missing convert anim to gsap 
		//this.view.style.visibility = "hidden";
		if( this.viewPIXIAPP != null ) this.viewPIXIAPP.visible = false;
		this.isLocked = false;
	}

	public IsLocked():boolean
	{
		return this.isLocked;
	}

	public AutoDenom()
	{
		if(this.denomSelectedCalback != null)
		{
			this.denomSelectedCalback(this.denomCents[0]);
		}
	}

	protected viewPIXIAPP: PIXI.Container = null;
	protected denomInfoPIXIAPP: PIXI.Container = null;
	protected sizePanelTexture = new Size (Scale.W(1550), Scale.H(338))
	public CreatePIXIAPP() {
		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.name = "DenomMenuViewPIXIAPP";
		this.viewPIXIAPP.position.set(0,Settings.ScreenHeight * (Settings.Screens - 1));
		this.viewPIXIAPP.visible = false;

		// let textureDenomView = new PIXI.Sprite(PIXI.Texture.WHITE);
		// textureDenomView.width = Settings.ScreenWidth;
		// textureDenomView.height = Settings.ScreenHeight;
		// // textureDenomView.tint = "black";
		// // textureDenomView.alpha = 0.8;
		// this.viewPIXIAPP.addChild(textureDenomView);

		this.denomInfoPIXIAPP = new PIXI.Container();				
		this.denomInfoPIXIAPP.position.set(Settings.ScreenWidth/2,Scale.Y(1095.5));		
		this.denomInfoPIXIAPP.pivot.set(Scale.W(1550)/2 , Scale.Y(550));
		this.denomInfoPIXIAPP.name = "denom-info";		
		this.viewPIXIAPP.addChild(this.denomInfoPIXIAPP);			

		let textureDenomInfo = new PIXI.Sprite(this.denomBackgroundImageTexturePIXI);
		textureDenomInfo.width = this.sizePanelTexture.Width;
		textureDenomInfo.height =  this.sizePanelTexture.Height;
		//textureDenomInfo.tint = "white";
		//textureDenomInfo.alpha = 0.8;
		this.denomInfoPIXIAPP.addChild(textureDenomInfo);

		let elementTextPIXIAPP = new PIXI.Text(service.translator.t.selectDenom, {
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: Scale.fh(90),			
			fontWeight: 'bold',
			fill: ["white"], // gradient
			stroke: 'black',
			strokeThickness:  Scale.fh(8),			
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        });
		
		elementTextPIXIAPP.anchor.set(0.5,0.5);
		elementTextPIXIAPP.position.set(Scale.W(1550)/2, Scale.H(80));
		service.translator.SetOnLanguageChangedCallback(()=>{
			elementTextPIXIAPP.text = service.translator.t.selectDenom;
		});

		this.denomInfoPIXIAPP.addChild(elementTextPIXIAPP);
		this.CreateDenomButtonsPIXIAPP();
		//return this.viewPIXIAPP;
	}

	public CreateDenomButtonsPIXIAPP(): void {
		let buttonContainer = new PIXI.Container();
		buttonContainer.name =  "buttonContainer";		
		this.denomInfoPIXIAPP.addChild(buttonContainer);
		buttonContainer.position.set(this.denomInfoPIXIAPP.width/2, Scale.Y(210));

		this.denomCents.forEach((cents,index) => {
			let buttonDenomPIXIAPP = new PIXI.Container();
			buttonDenomPIXIAPP.name = `buttonDenomPIXIAPP-${cents}`;
			buttonDenomPIXIAPP.interactive = true;
			buttonDenomPIXIAPP.addListener("pointerdown",()=>{
				if(this.denomSelectedCalback != null)
					{
						this.denomSelectedCalback(cents);
					}
			})
			//buttonDenomPIXIAPP.height = Scale.H(40);			
			buttonContainer.addChild(buttonDenomPIXIAPP);
			let textureButtonPIXI = new PIXI.Sprite(PIXI.Texture.WHITE);			
			textureButtonPIXI.height = Scale.H(90);		
			textureButtonPIXI.tint = "black";
			//textureButtonPIXI.alpha = 0.5;
			buttonDenomPIXIAPP.addChild(textureButtonPIXI);

			let unlockFeatureFrameSprite = new PIXI.NineSlicePlane(this.frameButtonImageTexturePIXI,1,1,1,1);            
            unlockFeatureFrameSprite.name = "unlockFeatureFrameSprite";
           // unlockFeatureFrameSprite.width = this.windowRectangle.width;
            unlockFeatureFrameSprite.height = Scale.H(90);
            buttonDenomPIXIAPP.addChild(unlockFeatureFrameSprite);

			if (this.denomCents.length <= 4) {				
				textureButtonPIXI.width = Scale.W(1550) * 0.16;
				unlockFeatureFrameSprite.width = Scale.W(1550) * 0.16;
			}
			else if (this.denomCents.length > 4) {
				textureButtonPIXI.width = (this.sizePanelTexture.Width / this.denomCents.length) * 0.90;
				unlockFeatureFrameSprite.width = (this.sizePanelTexture.Width / this.denomCents.length) * 0.90;
			}
			buttonDenomPIXIAPP.position.set(unlockFeatureFrameSprite.width * index,0);

			let textDenomCents = new PIXI.Text(service.moneyFormatter.FormatCurrency(cents),{
				fontFamily: 'NotoSansDisplay-Bold',			
				fontSize: Scale.fh(50),			
				fontWeight: 'bold',
				fill: ["white"], // gradient
				stroke: 'black',
				strokeThickness:  Scale.fh(8),			
				//wordWrap: true,			
				lineJoin: 'round',
				//textBaseline : "middle",			
			});

			textDenomCents.anchor.set(0.5,0.5);
			textDenomCents.position.set(buttonDenomPIXIAPP.width/2,buttonDenomPIXIAPP.height/2);
			buttonDenomPIXIAPP.addChild(textDenomCents);
		});

		buttonContainer.pivot.set(buttonContainer.width/2,buttonContainer.height/2);
	}
}